// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1pHTT","author":"Table_author__1CsUl","authorImage":"Table_authorImage__302-A","unreadRow":"Table_unreadRow__1G3tf"};